export class CrossPortCallsCondition {
    constructor(crossPortCallsConditionId: number, nextEventTypeGroupId: number, previousEventTypeGroupId: number) {
        this.crossPortCallsConditionId = crossPortCallsConditionId;
        this.nextEventTypeGroupId = nextEventTypeGroupId;
        this.previousEventTypeGroupId = previousEventTypeGroupId;
    }
    crossPortCallsConditionId: number;
    nextEventTypeGroupId: number;
    previousEventTypeGroupId: number;
}
